import { NavLink } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className='footer'>
      <h3 className='footer__title heading-infos'>Nous contacter</h3>

      <div className='contact__location'>
        <div className='footer__icon'>
          <img src='/icons/location.svg' alt='icône de localisation' />
        </div>
        <a href='https://maps.app.goo.gl/RS6J8JvE49VWsS4t8' className='lien-maps'>
          <p className='footer-text'>Maison de la vie associative</p>
          <p className='footer-text'>Rue des charmilles</p>
          <p className='footer-text'>50 000 Saint-Lô</p>
        </a>
      </div>

      <div className='contact__phone'>
        <div className='footer__icon'>
          <img src='/icons/phone.svg' alt='icône de localisation' />
        </div>
        <a href='tel:+650925932' className='footer-text lien-maps'>
          06 50 92 59 32
        </a>
      </div>

      <div className='contact__mail'>
        <div className='footer__icon'>
          <img src='/icons/mail.svg' alt='icône de lenvoi d un mail' />
        </div>
        <a href='mailto:yoga.taranga50@gmail.com' target='_' className='footer-text lien-maps'>
          yoga.taranga50@gmail.com
        </a>
      </div>

      <div className=' u-margin-top-medium '>
        <NavLink to={'/mentions-legales'} className={'mentions-legales'}>
          Mentions légales
        </NavLink>
      </div>
    </footer>
  );
}
